import React from "react";
import { Navbar } from "react-bootstrap";

const Footer = () => {
  return (
    <Navbar className="footer">
      <p className="footer-icon">🐈</p>
      <p className="footer-icon">🐈</p>
      <p className="footer-icon">🐈</p>
    </Navbar>
  );
};

export default Footer;
